module.exports = __webpack_public_path__ + "img/vue2-corpsavant_vert.42888e96.png";